import { convertFloatToPercentage } from './data-transform';

export const deforestationRiskMapping = (score: number | undefined) =>
  typeof score === 'number' ? (score > 0 ? 'high' : 'low') : 'processing';

export const deforestationDisturbance = (score: number | undefined) =>
  typeof score === 'number' ? convertFloatToPercentage(score) : '--';
